// You can write more code here

/* START OF COMPILED CODE */

import PlatformImageBase from '../PlatformImageBase';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class PlatformImage extends PlatformImageBase {
  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 27.5, y ?? 24, texture || 'game', frame ?? 'icon-grizz.png');

    /* START-USER-CTR-CODE */
    /* END-USER-CTR-CODE */
  }

  public zIndex: number = 0;

  /* START-USER-CODE */

  public init() {
    super.init();
  }

  public destroy(fromScene?: boolean | undefined): void {
    // if (this.hasCustomBody) {
    //   this.customBodies.forEach((body) => {
    //     this.scene.matter.world.remove(body);
    //     console.log("Custom body removed");
    //   });
    // }

    super.destroy(fromScene);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
